import { useMutation } from '@apollo/client';

import VerifyFieldsMutation from '@/graphql/contracts/verifyFields.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { VerifyFields, VerifyFieldsVariables } from '@/graphql/contracts/_generated_/verifyFields.mutation';
import { notificationService } from '@/services/notification/notification.client';

export type VerifyFieldsDto = VerifyFieldsVariables;

export function useVerifyFields() {

  const [_verifyFields, { loading }] = useMutation<VerifyFields, VerifyFieldsVariables>(
    VerifyFieldsMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    }
  );

  const verifyFields = (dto: VerifyFieldsDto, onSuccess?: () => void) => {
    _verifyFields({
      variables: dto,
      refetchQueries: ['GetPaginatedFieldVerifications'],
      onCompleted: () => {
        notificationService.open({
          title: 'Field Verification',
          text: 'Fields successfully verified',
          type: 'success',
        });

        onSuccess?.();
      },
    });
  };

  return {
    verifyFields,
    isLoading: loading,
  } as const;
}
